export default function Footer() {
  return (
    <footer className="bg-[#1B5E20] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Left: Logo and Description */}
          <div className="md:col-span-1 space-y-6">
            <div className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/bac9cc4b08f51c73312a598e4205cf6d.png" 
                alt="飛翠ロゴ" 
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-sm opacity-90 leading-relaxed">
              古物経験10年のベテラン吉田が、笑顔でご自宅までお伺いします。
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-4">サービス</h4>
            <ul className="space-y-3 text-sm opacity-90">
              <li><a href="#service" className="hover:text-[#00A58E] transition-colors">出張買取</a></li>
              <li><a href="#flow" className="hover:text-[#00A58E] transition-colors">ご利用の流れ</a></li>
              <li><a href="#catalog" className="hover:text-[#00A58E] transition-colors">買取品目</a></li>
              <li><a href="#faq" className="hover:text-[#00A58E] transition-colors">よくある質問</a></li>
            </ul>
          </div>

          {/* Company Info */}
          <div>
            <h4 className="font-bold text-lg mb-4">会社情報</h4>
            <ul className="space-y-3 text-sm opacity-90">
              <li><a href="#about" className="hover:text-[#00A58E] transition-colors">会社概要</a></li>
              <li><a href="#authority" className="hover:text-[#00A58E] transition-colors">古物商許可</a></li>
              <li><a href="#privacy" className="hover:text-[#00A58E] transition-colors">プライバシーポリシー</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">お問い合わせ</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-[#00A58E]"></i>
                <div>
                  <a href="tel:080-7347-9482" className="font-bold text-base hover:text-[#00A58E] transition-colors">080-7347-9482</a>
                  <p className="text-xs opacity-75 mt-1">受付時間：9:00〜18:00（年中無休）</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center mt-1 text-[#00A58E]"></i>
                <div className="leading-relaxed">
                  <p className="font-medium">〒231-0868</p>
                  <p className="opacity-90">神奈川県横浜市中区石川町1丁目13番地2</p>
                  <p className="opacity-90">エネクル横浜元町テラス1F</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-time-line w-5 h-5 flex items-center justify-center text-[#00A58E]"></i>
                <div>
                  <p className="font-medium">営業時間</p>
                  <p className="opacity-90">9:00〜18:00（年中無休）</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm opacity-75 text-center md:text-left">
            © 2025 KAITORIKAWASEMI All rights reserved.
          </p>
          
          <div className="flex items-center gap-6">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white/10 transition-colors">
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white/10 transition-colors">
              <i className="ri-twitter-x-line text-lg"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white/10 transition-colors">
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a href="https://lin.ee/FOUdDfw" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white/10 transition-colors">
              <i className="ri-line-fill text-lg"></i>
            </a>
          </div>

          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm opacity-75 hover:text-[#00A58E] transition-colors">
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}